<script>
export default {
  components: {},
  props: {
    prevPageName: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>

<template>
  <div class="btn-breadcrumbs">
    <span @click="$emit('to-route')">
      <img class="icon-back" src="@assets/images/icons/icon-left-arrow-small.svg" />
      <span class="prev-page-name">{{ prevPageName ? `Back to ${prevPageName}` : 'Back' }}</span>
    </span>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.btn-breadcrumbs {
  left: 3.7vw;
  position: absolute;

  &:hover {
    cursor: pointer;
  }

  span {
    align-items: center;
    display: flex;

    .prev-page-name {
      @include calc-font-size(1.3);

      color: white;
      font-weight: bold;
      line-height: 2.6rem;
      text-transform: capitalize;
    }

    h5:hover,
    img:hover {
      cursor: pointer;
    }

    .icon-back {
      margin-right: 1rem;
    }
  }
}
</style>
